import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginWithOAuth } from '../store/slices/authSlice';
import { fetchMe } from '../store/slices/authSlice';
import { toast } from 'react-toastify';

const OAuthCallback = () => {
  const [params] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const error = params.get('error');

    if (error || !token) {
      toast.error('Sign in failed. Please try again.');
      navigate('/login');
      return;
    }

    // Consume any saved returnTo before async work clears session state
    const returnTo = (() => {
      const raw = sessionStorage.getItem('oauth_return_to');
      sessionStorage.removeItem('oauth_return_to');
      return raw && raw.startsWith('/') ? raw : '/';
    })();

    localStorage.setItem('token', token);
    dispatch(fetchMe()).then((result) => {
      if (fetchMe.fulfilled.match(result)) {
        dispatch(loginWithOAuth({ token, user: result.payload.user }));
        navigate(returnTo);
      } else {
        localStorage.removeItem('token');
        toast.error('Sign in failed. Please try again.');
        navigate('/login');
      }
    });
  }, []);

  return (
    <div className="loading-page">
      <div className="loading-spinner" />
    </div>
  );
};

export default OAuthCallback;
